module.exports = __webpack_public_path__ + "static/assets/36ce3e63c4226f7f2885cea3148948f8.png";